import { Button, Center, Flex, Image, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";

import restrictedIcon from "/restriction.png";

import { AppRoute } from "../../constants";

export default function LoginAccessDeniedPage() {
  return (
    <Center mx="auto" h="100vh">
      <Flex direction="column" gap={50} align="center" maw="50%">
        <Title>Failed to Login</Title>
        <Image width={200} height={200} src={restrictedIcon} />

        <Flex direction="column">
          <Text align="center" color="red" size="lg">
            You are unable to sign in because your account has been deactivated.
          </Text>
          <Text align="center" size="lg">
            If you believe this is a mistake, please contact our customer
            support for assistance.
          </Text>
        </Flex>
        <Link to={AppRoute.Login}>
          <Button variant="filledBlue" uppercase size="md">
            Back
          </Button>
        </Link>
      </Flex>
    </Center>
  );
}
